import React from 'react';
import { Multiselect, Select } from 'AWS-UI-Components-React';
import { AccuracyButtonNewStyle } from '../../styles/common_styles';

export class SnapshotsButton extends React.Component {
  getSelected = (snapshots) => {
    if(this.props.multiselect){
      return snapshots.map(snapshot => snapshot.id);
    } else {
      return snapshots.length === 1 ? snapshots[0].id : this.props.liveSnapshotId;
    }
  };

  render() {
      return (
        <div id="snapshots" className={AccuracyButtonNewStyle}>
          <b> {this.props.text} </b>
          {this.props.multiselect && (
            <Multiselect
              options={this.props.options}
              label={this.props.text}
              onChange={this.props.onChange}
              loading={this.props.loading}
              loadingText={'Fetching Snapshots...'}
              placeholder="Snapshots"
              filteringType={'auto'}
              selectedIds={this.getSelected(this.props.selected)}
              disabled={this.props.disabled}
              keepOpen={false}
              data-cy={this.props['data-cy']}
              />)
          }
          {!this.props.multiselect && (
            <Select
              options={this.props.options}
              label={this.props.text}
              onChange={this.props.onChange}
              loading={this.props.loading}
              loadingText={'Fetching Snapshots...'}
              placeholder="Snapshots"
              filteringType={'auto'}
              selectedId={this.getSelected(this.props.selected)}
              disabled={this.props.disabled}
              keepOpen={false}
              data-cy={this.props['data-cy']}
            />
          )}
        </div>
      );
  }

  static defaultProps = {
    'data-cy': 'snapshots-button'
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/snapshots_button.jsx